import { render, staticRenderFns } from "./DashboardRadialChart.vue?vue&type=template&id=897b06e6&"
import script from "./DashboardRadialChart.vue?vue&type=script&lang=js&"
export * from "./DashboardRadialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports